import React from 'react'
import styled from 'styled-components';
import { Divider } from 'antd';

const StyledDivider = styled(Divider)`
    margin: 1rem 0 .2rem 0;
    position: relative;

    &::before, &::after {
        border-color: ${props => props.theme.BorderColor} !important;
    }

    .ant-divider-inner-text {
        font-size: .75rem;
        padding: 0 0.5em !important;
        text-transform: uppercase;
        opacity: .5;
    }
`

const NwDivider = ({ orientation = "left", children, ...other }) => {
    return (
        <StyledDivider orientation={orientation} {...other}>
            {children}
        </StyledDivider>
    )
}

export default NwDivider